<template>
  <div class="page" id="sign">
    <div class="tabs-container">
      <van-tabs
        v-model="active"
        animated
        color="#fff"
        background="transparent"
        title-active-color="#fff"
        title-inactive-color="#fff"
      >
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.title">
          <van-form
            @submit="onLoginSubmit"
            validate-trigger="onSubmit"
            v-show="index === 0"
          >
            <img class="text-welcome" src="@/assets/text-welcome.png" />
            <div class="label flex" v-i18n>手机号/昵称</div>
            <van-field
              class="flexC"
              v-model="formSignIn.username"
              name="username"
              placeholder="用户名"
              :rules="[{ required: true, message: '请填写用户名' }]"
            />
            <div class="label flex" v-i18n>密码</div>
            <van-field
              class="flexC"
              v-model="formSignIn.password"
              type="password"
              name="password"
              placeholder="密码"
              :rules="[{ required: true, message: '请填写密码' }]"
            />
         

            <router-link to="/reset" class="resetPwd">忘记密码</router-link>

            <div style="margin: 16px">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                color="linear-gradient(to right, #ffa726, #f5793f, #f25e28)"
              >
                {{ item.title }}
              </van-button>
            </div>
          </van-form>

          <van-form
            @submit="onSignupSubmit"
            validate-trigger="onSubmit"
            v-show="index === 1"
          >
            <img class="text-welcome" src="@/assets/text-welcome.png" />
            <div class="label flex" v-i18n>真实姓名</div>
            <van-field
              class="flexC"
              v-model="formSignUp.realname"
              name="realname"
              placeholder="真实姓名"
              :rules="[{ required: true, message: '请填写真实姓名' }]"
            />
            <div class="label flex" v-i18n>手机号/昵称</div>
            <van-field
              class="flexC"
              v-model="formSignUp.username"
              name="username"
              placeholder="手机号/昵称"
              :rules="[{ required: true, message: '请填写手机号/昵称' }]"
            />
            <div class="label flex" v-i18n>学员身份</div>
            <van-field name="radio">
              <template #input>
                <van-radio-group v-model="formSignUp.type" direction="horizontal">
                  <van-radio name="0">海外学员</van-radio>
                  <van-radio name="1">国内学员</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <div class="label flex" v-i18n>就读学校</div>
            <van-field
              class="flexC"
              v-model="formSignUp.school"
              name="school"
              placeholder="就读学校"
              :rules="[{ required: true, message: '请填写就读学校' }]"
            />
            <div class="label flex" v-i18n>家庭地址</div>
            <van-field
              class="flexC"
              v-model="formSignUp.address"
              name="address"
              placeholder="家庭地址"
              :rules="[{ required: true, message: '请填写家庭地址' }]"
            />
            <div class="label flex" v-i18n>微信号或邮箱</div>
            <van-field
              class="flexC"
              v-model="formSignUp.email"
              name="email"
              placeholder="微信号或邮箱"
              :rules="[{ required: true, message: '请填写微信号或邮箱' }]"
            />
            <div class="label flex" v-i18n>推荐方</div>
            <van-field
              class="flexC"
              v-model="formSignUp.reference"
              name="reference"
              placeholder="推荐方"
            />
            <div class="label flex" v-i18n>设置密码</div>
            <van-field
              class="flexC"
              v-model="formSignUp.password"
              name="password"
              type="password"
              placeholder="密码"
              :rules="[{ required: true, message: '请填写密码' }]"
            />
            <div class="label flex" v-i18n>重复密码</div>
            <van-field
              class="flexC"
              v-model="repeatPWD"
              name="password"
              type="password"
              placeholder="密码"
              :rules="[{ required: true, message: '请填写密码' }]"
            />
            
            <div style="margin: 16px">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                color="linear-gradient(to right, #ffa726, #f5793f, #f25e28)"
              >
                {{ item.title }}
              </van-button>
            </div>
          </van-form>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>